import { securedAxiosInstance } from "../axios";

class ThirdPartyActorsService {
  fetchAll() {
    return securedAxiosInstance.get("/third_party_actors");
  }
}

export default new ThirdPartyActorsService();
